import {
    get,
    post,
    execute
} from "../axios";

/**
 * 加入商品组合至购物车接口
 * @param {data} 
 * @return {Promise} 
 */
export const AddShopCart = data => execute('eshopapi/v1/ShoppingCart/Add', data)
// 店铺加购
export const ShopAddShopCart = data => execute('eshopapi/v1/ShoppingCart/ShopCartAdd', data)

/**
 * 批量加入商品组合至购物车接口
 * @param {data} 
 * @return {Promise} 
 */
export const BatchAddShopCart = data => execute('eshopapi/v1/ShoppingCart/BatchAdd', data)
// 店铺批量加购
export const ShopBatchAddShopCart = data => execute('eshopapi/v1/ShoppingCart/ShopCartBatchAdd', data)

/**
 * 更新商品购物车数量接口
 * @param {data} 
 * @return {Promise} 
 */
export const EditShopCart = data => execute('eshopapi/v1/ShoppingCart/ChangeGoodsCount', data)

/**
 * 删除购物车记录接口
 * @param {data} 
 * @return {Promise} 
 */
export const DelShopCart = data => execute('eshopapi/v1/ShoppingCart/Delete', data)

/**
 * 获取购物车列表接口
 * @param {data} 
 * @return {Promise} 
 */
export const GetShopCartList = data => execute('eshopapi/v1/ShoppingCart/GetList', data)
/**
 * 获取店铺购物车列表
 */
export const GetShopShopCartList = data => execute('eshopapi/v1/ShoppingCart/GetShopCartList', data)

/**
 * 修改购物车记录
 * @param {data} 
 * @return {Promise} 
 */
export const UpdateShopCart = data => execute('eshopapi/v1/ShoppingCart/Update', data)

/**
 * 清除失效商品
 * @param {data} 
 * @return {Promise} 
 */
export const DeleteInValidGoods = data => execute('eshopapi/v1/ShoppingCart/DeleteInValidGoods', data)

/**
 * 收藏商品组合接口
 * @param {data} 
 * @return {Promise} 
 */
export const AddCollection = data => execute('eshopapi/v1/GoodsCollection/Add', data)

/**
 * 删除收藏商品接口
 * @param {data} 
 * @return {Promise} 
 */
export const DelCollection = data => execute('eshopapi/v1/GoodsCollection/Delete', data)

/**
 * 判断商品是否被收藏
 * @param {data} 
 * @return {Promise} 
 */
export const IsCollection = data => execute('eshopapi/v1/GoodsCollection/IsCollectionMix', data)

/**
 * 获取商品收藏页商品分类列表（用于搜索）
 * @param {data} 
 * @return {Promise} 
 */
export const GetCollCategoryList = data => execute('eshopapi/v1/GoodsCollection/GetCategoryList', data)
/**
 * 获取收藏商品列表
 * @param {data} 
 * @return {Promise} 
 */
export const GetfollowGoodsList = data => execute('eshopapi/v1/GoodsCollection/GetSearchPageData', data)